import { observable, action, makeObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export interface UserAccessDTO {
  id: string;
  userId: string;
  employer: string;
  egNid: string;
  screens: string[];
  organization: string;
  deleted: boolean;
}
export interface UserResponse {
  id: string;
  firstName: string;
  lastName: string;
  organizationName: string;
  email: string;
  enabled: boolean;
  deleted: boolean;
  role: {
    id: string;
    name: string;
  };
  password: string;
  passwordReset: boolean;
  userAccessDTOList: UserAccessDTO[];
  organizationDTOList: string;
  cnId?: string;
  riskManagement?: boolean;
  riskManagementQuota?: number;
  riskManagementScreens?: string[];
  complianceAssuranceScreens?: string[];
  complianceAssurance?: boolean;
  complianceAssuranceQuota?: number;
  careNavigationScreens?: string[];
  careNavigation?: boolean;
  careNavigationQuota?: number;
  groups?: any[];
  totalGroups?: number;
  employerGroups?: any[];
}

export class LoginPageStore {
  email: string = '';
  firstName: string = '';
  lastName: string = '';
  isAdmin: boolean = false;
  isCareNavigator: boolean = false;
  memberIdentification: boolean = false;
  userId: string = '';
  userAccessRoutes: string[] = [];
  userFeatures: string[] = [];
  employerGroups: string[] = [];
  userResponse: UserResponse = {
    cnId: '',
    id: '',
    firstName: '',
    lastName: '',
    email: '',
    organizationName: '',
    enabled: false,
    deleted: false,
    role: {
      id: '',
      name: '',
    },
    password: '',
    passwordReset: false,
    userAccessDTOList: [],
    organizationDTOList: '',
  };

  constructor() {
    makeObservable(this, {
      email: observable,
      addUserData: action,
      removeUserData: action,
      isAdmin: observable,
      isCareNavigator: observable,
      setIsCareNavigator: action,
      memberIdentification: observable,
      setMemberIdentification: action,
      setIsAdmin: action,
      userId: observable,
      userAccessRoutes: observable,
      addUserAccessRoutes: action,
      removeUserAccessRoutes: action,
      userFeatures: observable,
      addUserFeatures: action,
      employerGroups: observable,
      addEmployerGroups: action,
      removeUserFeatures: action,
      userResponse: observable,
      addUserResponse: action,
      removeUserResponse: action,
    });

    makePersistable(this, {
      name: 'LoginPageStore',
      properties: [
        'email',
        'firstName',
        'lastName',
        'isAdmin',
        'userId',
        'userAccessRoutes',
        'userFeatures',
        'employerGroups',
        'userResponse',
        'isCareNavigator',
        'memberIdentification',
      ],
      storage: window.localStorage,
    });
  }

  addUserData(email: string, firstName: string, lastName: string) {
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
  }

  addUserName(firstName: string, lastName: string) {
    this.firstName = firstName;
    this.lastName = lastName;
  }

  removeUserData() {
    this.email = '';
    this.firstName = '';
    this.lastName = '';
    this.userId = '';
    this.isAdmin = false;
    this.userAccessRoutes = [];
    this.userFeatures = [];
    this.employerGroups = [];
    this.userResponse = {
      id: '',
      firstName: '',
      lastName: '',
      email: '',
      organizationName: '',
      enabled: false,
      deleted: false,
      role: {
        id: '',
        name: '',
      },
      password: '',
      passwordReset: false,
      userAccessDTOList: [],
      organizationDTOList: '',
    };
  }

  setIsAdmin(isAdmin: boolean) {
    this.isAdmin = isAdmin;
  }

  setIsCareNavigator(isCareNavigator: boolean) {
    this.isCareNavigator = isCareNavigator;
  }

  setMemberIdentification(memberIdentification: boolean) {
    this.memberIdentification = memberIdentification;
  }

  addUserId(userId: string) {
    this.userId = userId;
  }

  addUserAccessRoutes(userAccessRoutes: string[]) {
    this.userAccessRoutes = userAccessRoutes;
  }

  removeUserAccessRoutes() {
    this.userAccessRoutes = [];
  }

  addUserFeatures(userFeatures: string[]) {
    this.userFeatures = userFeatures;
  }

  removeUserFeatures() {
    this.userFeatures = [];
  }
  addEmployerGroups(employerGroups: string[]) {
    this.employerGroups = employerGroups;
  }
  removeEmployerGroups() {
    this.employerGroups = [];
  }
  addUserResponse(userResponse: UserResponse) {
    this.userResponse = userResponse;
  }

  removeUserResponse() {
    this.userResponse = {
      id: '',
      firstName: '',
      lastName: '',
      organizationName: '',
      email: '',
      enabled: false,
      deleted: false,
      role: {
        id: '',
        name: '',
      },
      password: '',
      passwordReset: false,
      userAccessDTOList: [],
      organizationDTOList: '',
    };
  }
}
export default LoginPageStore;
